var _link, _link2, _style, _style2, _style3, _path, _path2, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNegative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-custom-link"
  })), _link2 || (_link2 = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-general-link"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-style"
  })), _style3 || (_style3 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-sheet"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.57735 9.94922C0.220085 9.33042 0.220085 8.56802 0.57735 7.94922L3.42265 3.02102C3.77992 2.40221 4.44017 2.02102 5.1547 2.02102H10.8453C11.5598 2.02102 12.2201 2.40221 12.5773 3.02102L15.4226 7.94922C15.7799 8.56802 15.7799 9.33042 15.4226 9.94922L12.5773 14.8774C12.2201 15.4962 11.5598 15.8774 10.8453 15.8774H5.1547C4.44017 15.8774 3.77992 15.4962 3.42265 14.8774L0.57735 9.94922Z",
    fill: "#434240"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.762 5.71513C4.88478 5.59239 5.05128 5.52344 5.22489 5.52344C5.39849 5.52344 5.56499 5.59239 5.68777 5.71513L8.00284 8.0302L10.3179 5.71513C10.4414 5.59587 10.6068 5.52988 10.7784 5.53137C10.9501 5.53286 11.1143 5.60171 11.2357 5.7231C11.3571 5.84449 11.4259 6.0087 11.4274 6.18037C11.4289 6.35203 11.3629 6.51741 11.2437 6.64089L8.9286 8.95596L11.2437 11.271C11.3629 11.3945 11.4289 11.5599 11.4274 11.7316C11.4259 11.9032 11.3571 12.0674 11.2357 12.1888C11.1143 12.3102 10.9501 12.3791 10.7784 12.3806C10.6068 12.382 10.4414 12.3161 10.3179 12.1968L8.00284 9.88173L5.68777 12.1968C5.56429 12.3161 5.39891 12.382 5.22724 12.3806C5.05558 12.3791 4.89137 12.3102 4.76998 12.1888C4.64859 12.0674 4.57973 11.9032 4.57824 11.7316C4.57675 11.5599 4.64274 11.3945 4.762 11.271L7.07707 8.95596L4.762 6.64089C4.63926 6.51812 4.57031 6.35162 4.57031 6.17801C4.57031 6.0044 4.63926 5.83791 4.762 5.71513V5.71513Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.1412,
    y1: 9.01116,
    x2: 13.4269,
    y2: 9.01116,
    stroke: "white",
    strokeWidth: 0.571429,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.c710edfbb05846873606834fe49136be.svg";
export { ForwardRef as ReactComponent };